"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useErrorReporter = exports.ErrorReporterContext = exports.SentryErrorReporter = exports.ConsoleErrorReporter = void 0;
var browser_1 = require("@sentry/browser");
var react_1 = require("react");
var React = __importStar(require("react"));
var ConsoleErrorReporter = /** @class */ (function () {
    function ConsoleErrorReporter() {
        this.report = function (e) {
            console.error(e);
        };
        this.reportApolloError = function (e) {
            console.error(e);
        };
    }
    return ConsoleErrorReporter;
}());
exports.ConsoleErrorReporter = ConsoleErrorReporter;
var SentryErrorReporter = /** @class */ (function () {
    function SentryErrorReporter() {
        this.report = function (e) {
            console.error(e);
            (0, browser_1.captureException)(e);
        };
        this.reportApolloError = function (e) {
            console.error(e);
            (0, browser_1.captureException)(Object.assign(new Error(e.message), {
                graphqlErrors: JSON.stringify(e.graphQLErrors),
                networkError: JSON.stringify(e.networkError),
                extraInfo: JSON.stringify(e.extraInfo),
            }));
        };
    }
    return SentryErrorReporter;
}());
exports.SentryErrorReporter = SentryErrorReporter;
// TODO: Provide functionality to send errors to sentry.
exports.ErrorReporterContext = React.createContext(new ConsoleErrorReporter());
function useErrorReporter() {
    return (0, react_1.useContext)(exports.ErrorReporterContext);
}
exports.useErrorReporter = useErrorReporter;
//# sourceMappingURL=error-reporter.js.map